export default __webpack_public_path__ + "static/media/emptyEarnings.8ec3ecfb.svg";